export default __webpack_public_path__ + "static/media/dental-plan.4f689661.svg";